import classNames from "classnames";
import Modal from "components/modalContainer";
import { Button, Container, Typography } from "ct-design";
import Cross from "icons/cross.svg";
import { FunctionComponent, ReactNode } from "react";

interface AlertPopProps {
  title: string | ReactNode;
  description?: string | ReactNode;
  buttonTitle?: string;
  buttonOnClick?: () => void;
  onClose: () => void;
  show: boolean;
  Icon?: ReactNode;
  centerAlign?: boolean;
  htmlContent?: ReactNode;
  alertButton?: boolean;
  loading?: boolean;
  maxWidth?: string;
  textAlign?: boolean;
  descriptionClass?: string;
}
const AlertPopup: FunctionComponent<AlertPopProps> = (props) => {
  const {
    title,
    description,
    buttonTitle,
    buttonOnClick,
    onClose,
    show,
    Icon,
    centerAlign = true,
    htmlContent,
    alertButton = false,
    loading = false,
    maxWidth,
    textAlign,
    descriptionClass = "",
  } = props;

  const contentClasses = classNames(
    "br-13 flex bg-neutral-100 flex-center  flex-column p-6",
    {
      "flex-middle": centerAlign,
      "ta-center": textAlign,
    }
  );
  const desctiptionClass = classNames("mt-4", descriptionClass, {
    "ta-center": textAlign,
  });

  return show ? (
    <Modal onClose={onClose}>
      <Container className="p-relative" css={{ maxWidth: maxWidth }}>
        <Container
          className="bg-neutral-100 p-absolute br-50p p-1 flex flex-center c-pointer  "
          css={{
            top: "-44px",
            right: "0px",
          }}
          onClick={onClose}
        >
          <Cross />
        </Container>
        <Container css={{ minWidth: "390px" }} className={contentClasses}>
          {Icon ? Icon : null}
          <Typography variant="HM1" className="">
            {title}
          </Typography>

          {description ? (
            <Typography className={desctiptionClass} variant="B2">
              {description}
            </Typography>
          ) : null}

          {htmlContent ? <div className="mt-4">{htmlContent}</div> : null}
          {buttonTitle && buttonOnClick ? (
            <Container className="mt-10 w-100p h-12">
              <Button
                id={alertButton ? "alertBtn" : "normalBTn"}
                isFullWidth
                color="primary"
                onClick={buttonOnClick}
                loading={loading}
              >
                <Typography variant="L1" colorCode="#FFFFFF">
                  {buttonTitle}
                </Typography>
              </Button>
            </Container>
          ) : null}
        </Container>
      </Container>
    </Modal>
  ) : null;
};

export default AlertPopup;
